import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import { LayoutDashboard, Coffee, Calendar, Settings, LogOut, Shield, CreditCard, Bell, Receipt, Mail, BarChart3, MapPin, FileEdit, Award } from "lucide-react";
import Logo from "./Logo";

export default function DashboardLayout({ children, isSuper = false }) {
  const { user, logout } = useAuth();
  const { t, lang, setLang } = useI18n();
  const nav = useNavigate();

  const items = isSuper ? [
    { to: "/super-admin", end: true, icon: Shield, label: "Vue d'ensemble" },
    { to: "/super-admin/subscriptions", icon: CreditCard, label: "Abonnements" },
    { to: "/super-admin/payments", icon: Receipt, label: "Paiements" },
    { to: "/super-admin/invoices", icon: Receipt, label: "Factures" },
    { to: "/super-admin/visitors", icon: BarChart3, label: "Visiteurs" },
    { to: "/super-admin/content", icon: FileEdit, label: "Contenu (CMS)" },
    { to: "/super-admin/sponsors", icon: Award, label: "Sponsors" },
    { to: "/super-admin/alerts", icon: Bell, label: "Alertes" },
    { to: "/super-admin/emails", icon: Mail, label: "Emails" },
  ] : [
    { to: "/dashboard", end: true, icon: LayoutDashboard, label: t("dash.overview") },
    { to: "/dashboard/billing", icon: CreditCard, label: "Abonnement" },
    { to: "/dashboard/invoices", icon: Receipt, label: "Factures" },
    { to: "/dashboard/menu", icon: Coffee, label: t("dash.menu") },
    { to: "/dashboard/reservations", icon: Calendar, label: t("dash.reservations") },
    { to: "/dashboard/settings", icon: Settings, label: t("dash.settings") },
  ];

  return (
    <div data-testid="dashboard-layout" className="min-h-screen flex bg-[#0A0908]">
      <aside data-testid="sidebar" className="hidden lg:flex w-64 bg-[#0E0C0B] border-r border-white/5 flex-col">
        <div className="p-6 border-b border-white/5">
          <div className="flex items-center gap-3">
            <Logo size={36} variant="mark" />
            <div>
              <div className="font-serif text-[#F5F0EB] text-lg tracking-[0.18em]">
                <span className="text-[#C5A059]">CAFÉ-</span>SPOT
              </div>
              <div className="text-[10px] tracking-[0.32em] text-[#A8A39D] uppercase">{isSuper ? "Console" : "Atelier"}</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 py-4">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={`side-${it.to.replace(/\//g, "-")}`}
              className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
            >
              <it.icon size={16} />
              <span>{it.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-6 border-t border-white/5">
          <div className="text-xs text-[#A8A39D] mb-1 truncate">{user?.name}</div>
          <div className="text-[11px] tracking-widest text-[#C5A059] uppercase mb-4">{user?.role?.replace("_", " ")}</div>
          <div className="flex items-center gap-2 text-xs tracking-[0.2em] text-[#A8A39D] mb-4">
            <button onClick={() => setLang("fr")} className={lang === "fr" ? "text-[#C5A059]" : ""}>FR</button>
            <span>/</span>
            <button onClick={() => setLang("en")} className={lang === "en" ? "text-[#C5A059]" : ""}>EN</button>
          </div>
          <button data-testid="side-logout" onClick={() => { logout(); nav("/"); }} className="nav-item w-full !pl-0">
            <LogOut size={14} /><span>{t("nav.logout")}</span>
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <div className="lg:hidden bg-[#0E0C0B] border-b border-white/5 p-4 flex items-center justify-between">
          <div className="font-serif text-xl tracking-[0.18em]"><span className="text-[#C5A059]">CAFÉ-</span>SPOT</div>
          <button onClick={() => { logout(); nav("/"); }} className="text-xs uppercase tracking-widest text-[#A8A39D]">{t("nav.logout")}</button>
        </div>
        {children}
      </main>
    </div>
  );
}
